export default "__VITE_ASSET__BmcSKqNc__"